/* prettier-ignore */
export const SAMPLE_DATES = [
	new Date(),
	new Date("2023-01-01T00:00:00.000Z"),
] as const;
